import { render } from "./BackupPage.vue?vue&type=template&id=3c199825&ts=true"
import script from "./BackupPage.ts?vue&type=script&lang=ts&external"
export * from "./BackupPage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__